/*
 * @Descripttion:产品池属性
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2021-10-27 17:24:31
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const productpoolprobability = {
    // 列表
    list(params) {
        return axios.get(api + 'productpool/getgoodrule', { params: params })
    },
    //修改
    change(params) {
        return axios.post(api + 'productpool/postgoodrule', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'productpool/delgoodrule', qs.stringify(params))
    }
}


// 导出接口
export default productpoolprobability

